/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Fieldobject } from './_mixin.mixin';

export default $ => css`
  ${new Fieldobject('soporteDebidaDiligencia').include($, css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;

    .file-input > .input-group-text {
      width: 10em;
    }
    .aditionalFiles {
      grid-column-start: 1;
      grid-column-end: 3;
    }
  `)}
`;
